<script>
import { periodicTasksCrontabScheduleMethods } from '@state/helpers'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CrontabScheduleForm',
  components: {},
  props: {
    instanceJson: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    oncomplete: {
      type: Function,
      required: false,
      default: () => ({}),
    },
    oncancel: {
      type: Function,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      modalShow: true,
      loading: true,
      submitting: false,
      action: 'create',
      form: {
        url: null,
        minute: '*',
        hour: '*',
        day_of_week: '*',
        day_of_month: '*',
        month_of_year: '*',
        timezone: 'America/Bogota',
      },
    }
  },
  validations: {
    form: {
      minute: {
        required,
      },
      hour: {
        required,
      },
      day_of_week: {
        required,
      },
      day_of_month: {
        required,
      },
      month_of_year: {
        required,
      },
      timezone: {
        required,
      },
    },
  },
  computed: {},

  mounted: function () {
    let context = this
    if (context.instanceJson.url) {
      context.action = 'update'
      context.form = {
        ...context.instanceJson,
      }
      context.getObject()
    } else {
      context.action = 'create'
      context.loading = false
    }
  },

  methods: {
    ...periodicTasksCrontabScheduleMethods,

    getObject() {
      let context = this
      if (context.action == 'update') {
        const promise = context.fetchPeriodicTasksCrontabScheduleDetail(
          context.form.url
        )
        return promise
          .then((data) => {
            context.form = { ...data }
            context.loading = false
          })
          .catch((error) => {
            context.$axios_error_noty(error, context)
            context.loading = false
          })
      }
    },

    submit() {
      let context = this
      context.submitting = true
      context.$v.form.$touch()
      if (context.$v.form.$invalid) {
        context.$generate_toast(
          context,
          'error',
          'Por favor llene todos los campos requeridos'
        )
        return
      }
      const promise = context.createUpdatePeriodicTasksCrontabSchedule(
        context.form
      )
      return promise
        .then((data) => {
          context.$generate_toast(
            context,
            'success',
            `Crontab ${
              context.action == 'create' ? 'creado' : 'actualizado'
            } correctamente`
          )
          setTimeout(() => {
            context.oncomplete(data.url)
            context.submitting = false
          }, 3000)
        })
        .catch((error) => {
          context.submitting = false
          context.$axios_error_noty(error, context)
        })
    },
  },
}
</script>

<template>
  <b-modal
    v-model="modalShow"
    :title="action === 'create' ? $t('create.edit') : $t('basic.edit')"
    :size="action === 'create' ? 'md' : 'md'"
    @hidden="oncancel"
    @ok.prevent="submit"
  >
    <b-container class="p-0">
      <b-row v-if="loading">
        <b-col md="12">
          <div class="text-center">
            <b-spinner
              label="Spinning"
              style="color: #195db2; width: 4rem; height: 4rem"
            ></b-spinner>
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col md="12">
          <p
            >Más documentación acerca de crontab aquí:
            <a href="https://crontab.guru" target="_blank">crontab.guru</a></p
          >
          <p
            >Lista de zonas horarias permitidas:
            <a
              href="https://en.wikipedia.org/wiki/List_of_tz_database_time_zones"
              target="_blank"
              >Wikipedia.org</a>
              <br>
              Usar el valor textual de la columna TZ database name
              ej. America/Bogota
          </p>

          <b-form id="form">
            <form-wrapper :validator="$v.form">
              <div>
                <form-summary />
              </div>
              <form-group name="minute" label="Minuto" attribute="Minuto">
                <b-form-input
                  v-model="form.minute"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
              <form-group name="hour" label="Hora" attribute="Hora">
                <b-form-input
                  v-model="form.hour"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
              <form-group
                name="day_of_month"
                label="Día del mes"
                attribute="Día del mes"
              >
                <b-form-input
                  v-model="form.day_of_month"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
              <form-group
                name="month_of_year"
                label="Mes del año"
                attribute="Mes del año"
              >
                <b-form-input
                  v-model="form.month_of_year"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
              <form-group
                name="day_of_week"
                label="Día de la semana"
                attribute="Día de la semana"
              >
                <b-form-input
                  v-model="form.day_of_week"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
              <form-group
                name="timezone"
                label="Zona horaria"
                attribute="Zona horaria"
                helptext="ej1. America/Bogota, ej2. UTC"
              >
                <b-form-input
                  v-model="form.timezone"
                  slot-scope="{ attrs, listeners }"
                  v-bind="attrs"
                  v-on="listeners"
                />
              </form-group>
            </form-wrapper>
          </b-form>
        </b-col>
      </b-row>
    </b-container>
    <template v-slot:modal-footer="{ ok, cancel }">
      <b-button size="sm" variant="secondary" @click="cancel">
        {{ $t('basic.cancel') }}
      </b-button>

      <b-button
        size="sm"
        variant="primary"
        :class="{ disabled: submitting }"
        @click="ok"
      >
        <b-spinner v-if="submitting" label="Spinning" small></b-spinner>
        <span v-if="submitting"> Guardando </span>
        <span v-else>
          <i class="fad fa-floppy-disk"></i>
          {{ $t('basic.save') }}
        </span>
      </b-button>
    </template>
  </b-modal>
</template>
<style lang="scss">
</style>